export function hideRangeScale(el, input, scale) {
    scale.classList.add('none');
    el.closest('.range').classList.remove('active');
    input.closest('.form-field').classList.remove('none');

    setTimeout(() => {
        scale.classList.remove('none');
    }, 500)
}
